/**
 * An enumeration of the options for whether a clause link is required for clauses in MCHW documents.
 */
export enum ClauseLinkRequired {
  YES = 'YES',
  NO = 'NO',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  NOT_FOR_CLAUSE_TYPE = 'NOT_FOR_CLAUSE_TYPE',
}
